export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À Propos',
      products: 'Produits',
      origin: 'Origine',
      quality: 'Qualité',
      whyDifferent: 'Notre Différence',
      buyingGuide: "Guide d'Achat",
      quote: 'Demander un Devis',
      contact: 'Contact',
    },
    common: {
      learnMore: 'En Savoir Plus',
      discoverProducts: 'Découvrir nos Produits',
      requestQuote: 'Demander un Devis',
      contactUs: 'Nous Contacter',
      send: 'Envoyer',
      sending: 'Envoi en cours...',
      successTitle: 'Message envoyé !',
      successMsg: 'Nous vous répondrons dans les plus brefs délais.',
      errorMsg: 'Une erreur est survenue. Veuillez réessayer.',
      required: 'Champ requis',
      catalogueDownload: 'Télécharger notre Catalogue',
      certifications: 'Certifications',
      origin: 'Origine',
    },
    home: {
      overline: '', // Supprimé pour laisser la place au grand titre
      heroTitle: 'VANELYS',
      heroTitleAccent: 'VENUE DU PARADIS',
      heroDesc: 'VANELYS est une entreprise française basée à Nice, spécialisée dans la distribution de gousses de vanille gourmandes de haute qualité, sourcées directement auprès des producteurs.',
      ctaQuote: 'Demander un Devis',
      ctaContact: 'Nous Contacter',
      strengthsOverline: 'Nos Engagements',
      strengthsTitle: 'Pourquoi Choisir VANELYS',
      s1Title: 'Sourçage Direct',
      s1Desc: 'Partenariats directs avec les producteurs pour une qualité maximale et des conditions équitables.',
      s2Title: 'Traçabilité Totale',
      s2Desc: 'Chaque gousse est tracée de la ferme à votre porte avec une transparence absolue.',
      s3Title: 'Qualité Premium',
      s3Desc: 'Sélection rigoureuse des meilleures gousses pour une expérience gustative exceptionnelle.',
      s4Title: 'Agriculture Durable',
      s4Desc: "Partenariats durables avec des agriculteurs engagés dans une production responsable.",
      chainOverline: 'Notre Chaîne',
      chainTitle: 'Du Producteur au Client',
      chainDesc: 'Une chaîne d\'approvisionnement maîtrisée de bout en bout pour garantir fraîcheur et qualité.',
      chainStep1: 'Producteurs',
      chainStep2: 'Récolte',
      chainStep3: 'Affinage',
      chainStep4: 'Sélection',
      chainStep5: 'Export',
      chainStep6: 'Clients',
      galleryOverline: 'Notre Sélection',
      galleryTitle: 'Les Plus Belles Gousses du Monde',
      galleryDesc: 'Une collection soigneusement sélectionnée de vanilles d\'exception, pour les professionnels et les amateurs éclairés.',
      missionOverline: 'Notre Mission',
      missionTitle: 'L\'Excellence Vanille à la Française',
      missionDesc: 'VANELYS s\'engage à vous fournir les meilleures gousses de vanille du monde, en alliant traçabilité, qualité premium et partenariats durables. Que vous soyez professionnel de la gastronomie ou passionné de cuisine, nous avons la vanille qu\'il vous faut.',
      missionCta: 'Découvrir nos Produits',
    },
    about: {
      overline: 'À Propos de VANELYS',
      heroTitle: 'L\'Art de la Vanille',
      heroSubtitle: 'd\'Exception',
      heroDesc: 'Une entreprise française fondée à Nice avec une ambition internationale : mettre la vanille la plus pure du monde entre les mains des meilleurs.',
      storyOverline: 'Notre Histoire',
      storyTitle: 'Nés à Nice, Sourcés dans le Monde',
      storyDesc1: 'VANELYS est née d\'une passion profonde pour la vanille et d\'une conviction : les meilleures gousses méritent d\'être entre les mains des professionnels et des amateurs les plus exigeants.',
      storyDesc2: 'Basée à Nice, au cœur de la Côte d\'Azur, notre entreprise rayonne à travers la France, l\'Europe et les marchés internationaux. Nous bâtissons des relations durables avec des producteurs certifiés biologiques, Ecocert, Fair Trade et USDA Organic.',
      storyDesc3: 'Notre philosophie : transparence totale, qualité irréprochable et respect des producteurs.',
      valuesOverline: 'Nos Valeurs',
      valuesTitle: 'Ce Qui Nous Guide',
      v1Title: 'Transparence',
      v1Desc: 'Traçabilité complète de chaque gousse, de la ferme à votre cuisine.',
      v2Title: 'Excellence',
      v2Desc: 'Sélection rigoureuse et contrôle qualité à chaque étape.',
      v3Title: 'Durabilité',
      v3Desc: 'Partenariats à long terme favorisant une agriculture respectueuse.',
      v4Title: 'Passion',
      v4Desc: 'Un amour profond pour la vanille et les arômes d\'exception.',
      timelineOverline: 'Notre Vision',
      timelineTitle: 'De Nice au Monde Entier',
      t1Year: 'Fondation',
      t1Desc: 'VANELYS naît à Nice avec la vision de distribuer la vanille premium directement des producteurs aux professionnels.',
      t2Year: 'France',
      t2Desc: 'Développement du réseau de distribution en France, auprès des chefs pâtissiers, restaurants et marques gastronomiques.',
      t3Year: 'Europe',
      t3Desc: 'Extension vers les marchés européens : Belgique, Suisse, Allemagne, Royaume-Uni et au-delà.',
      t4Year: "International",
      t4Desc: 'Ambition mondiale : export vers les marchés premium d\'Amérique du Nord, d\'Asie et du Moyen-Orient.',
      locationTitle: 'Nice, France',
      locationDesc: 'Au cœur de la Côte d\'Azur, VANELYS opère depuis Nice, ville internationale reconnue pour son raffinement et son art de vivre.',
    },
    products: {
      overline: 'Nos Produits',
      heroTitle: 'Une Sélection',
      heroTitleAccent: 'd\'Exception',
      heroDesc: 'Des gousses de vanille premium sourcées directement auprès de producteurs certifiés, pour les professionnels et les particuliers exigeants.',
      vanillaOverline: 'Vanille Premium',
      vanillaTitle: 'Gousses de Vanille Gourmandes',
      vanillaDesc: 'Nos gousses de vanille sont sélectionnées avec la plus grande rigueur parmi les meilleures productions mondiales. Charnues, luisantes, à forte teneur en vanilline et au profil aromatique incomparable.',
      vanillaP1: 'Teneur élevée en vanilline pour un parfum intense',
      vanillaP2: 'Gousses charnues de 15 à 20 cm',
      vanillaP3: 'Texture huileuse et souple, signe de qualité',
      vanillaP4: 'Profil aromatique riche : crème, caramel, épices',
      formatsTitle: 'Conditionnements Disponibles',
      f1Title: 'Gousses Gourmandes',
      f1Desc: 'Conditionnement premium pour particuliers et chefs. Gousses de qualité A, emballées individuellement.',
      f2Title: 'Approvisionnement en Vrac',
      f2Desc: 'Solutions sur mesure pour les professionnels : pâtisseries, glaciers, industrie agroalimentaire.',
      f3Title: 'Quantités Professionnelles',
      f3Desc: 'Contrats d\'approvisionnement réguliers pour les grands comptes et distributeurs.',
      originsTitle: 'Nos Origines',
      origin1: 'Madagascar',
      origin1Desc: 'La reine de la vanille mondiale. Arôme crémeux, floral et boisé.',
      origin2: 'Tahiti',
      origin2Desc: 'Vanille rare aux notes florales d\'anis et de cerise. Très prisée des chefs.',
      origin3: 'Indonésie',
      origin3Desc: 'Notes boisées et fumées. Idéale pour les préparations chocolatées.',
      origin4: 'Mexique',
      origin4Desc: 'Berceau historique de la vanille. Notes épicées et florales caractéristiques.',
      brokerageOverline: 'Activité Complémentaire',
      brokerageTitle: 'Courtage de Matières Premières',
      brokerageDesc: 'Au-delà de la vanille, VANELYS accompagne ses clients dans leur approvisionnement en matières premières tropicales. Notre réseau international nous permet d\'intervenir sur des produits complémentaires.',
      b1Title: 'Cacao',
      b1Desc: 'Fèves de cacao premium, sourçage direct auprès de coopératives certifiées d\'Afrique et d\'Amérique Latine.',
      b2Title: 'Fruits Tropicaux',
      b2Desc: 'Fruits exotiques et tropicaux de qualité export, sélectionnés directement à la source.',
      b3Title: 'Légumes',
      b3Desc: 'Légumes biologiques et conventionnels, pour les marchés de gros et la distribution spécialisée.',
      catalogueTitle: 'Catalogue Complet',
      catalogueDesc: 'Téléchargez notre catalogue de produits pour découvrir l\'ensemble de notre offre.',
    },
    origin: {
      overline: 'L\'Origine de la Vanille',
      heroTitle: 'La Route',
      heroTitleAccent: 'de la Vanille',
      heroDesc: 'De la fleur d\'orchidée à la gousse séchée : un voyage fascinant à travers les tropiques.',
      introTitle: 'La Plante la Plus Mystérieuse du Monde',
      introDesc: 'La vanille (Vanilla planifolia) est la seule orchidée à produire un fruit comestible. Originaire du Mexique, elle est aujourd\'hui cultivée dans les régions tropicales du monde entier. Chaque étape de sa production est un acte d\'artisanat.',
      whereTitle: 'Où Pousse la Vanille ?',
      whereDesc: 'La vanille prospère dans une ceinture tropicale étroite, entre les tropiques du Cancer et du Capricorne. Elle a besoin d\'un climat chaud et humide, d\'un sol bien drainé et d\'un tuteur pour grimper.',
      regionsTitle: 'Les Grandes Régions Productrices',
      r1: 'Madagascar & Comores',
      r1Desc: '80% de la production mondiale. Arôme crémeux et intense, riche en vanilline.',
      r2: 'Tahiti & Polynésie',
      r2Desc: 'Vanille rare (Vanilla tahitensis). Notes florales uniques, anisées et fruitées.',
      r3: 'Indonésie & Java',
      r3Desc: 'Deuxième producteur mondial. Notes boisées, légèrement fumées.',
      r4: 'Mexique',
      r4Desc: 'Berceau historique. Production artisanale, notes épicées et florales.',
      pollinationTitle: 'La Pollinisation à la Main',
      pollinationDesc: 'La vanille ne peut être pollinisée naturellement qu\'au Mexique, par une abeille endémique et un colibri spécifique. Partout ailleurs, chaque fleur est pollinisée à la main, en quelques heures seulement lors de sa courte floraison.',
      pollinationFact: 'Chaque fleur n\'est ouverte que quelques heures. Les agriculteurs parcourent les plantations chaque matin pour polliniser à la main.',
      harvestTitle: 'La Récolte',
      harvestDesc: 'Les gousses de vanille mûrissent pendant 9 mois après la pollinisation. Elles sont récoltées avant complète maturité, lorsqu\'elles commencent tout juste à jaunir à leur extrémité.',
      curingTitle: 'Le Processus d\'Affinage',
      curingDesc: 'L\'affinage est l\'étape cruciale qui développe les 200+ composés aromatiques de la vanille. Ce processus traditionnel dure plusieurs mois et comprend plusieurs phases essentielles.',
      c1Title: 'Échaudage',
      c1Desc: 'Plongée dans l\'eau chaude à 65°C pour arrêter la végétation et initier les réactions enzymatiques.',
      c2Title: 'Étuvage',
      c2Desc: 'Enveloppées dans des couvertures, les gousses suent pendant 24-48h pour développer leurs arômes.',
      c3Title: 'Séchage',
      c3Desc: 'Séchage lent au soleil pendant plusieurs semaines pour réduire le taux d\'humidité.',
      c4Title: 'Conditionnement',
      c4Desc: 'Tri manuel, sélection et conditionnement des gousses selon les grades de qualité.',
    },
    quality: {
      overline: 'Qualité & Traçabilité',
      heroTitle: 'Notre Engagement',
      heroTitleAccent: 'Qualité',
      heroDesc: 'Du producteur à votre cuisine : chaque gousse porte notre signature de qualité.',
      standardsOverline: 'Nos Standards',
      standardsTitle: 'Les Critères VANELYS',
      s1Title: 'Sourçage Direct',
      s1Desc: 'Nous travaillons directement avec les producteurs, sans intermédiaire. Cela garantit la traçabilité et des conditions équitables pour tous.',
      s2Title: 'Contrôle Qualité Rigoureux',
      s2Desc: 'Chaque lot est inspecté : longueur des gousses, teneur en humidité, aspect visuel, profil aromatique et teneur en vanilline.',
      s3Title: 'Traçabilité Complète',
      s3Desc: 'Chaque livraison est accompagnée de sa documentation complète : origine, producteur, certification, date de récolte.',
      s4Title: 'Partenariats Durables',
      s4Desc: 'Nos relations avec les producteurs s\'inscrivent dans la durée. Nous investissons dans leur développement et leur bien-être.',
      processOverline: 'Notre Processus',
      processTitle: 'De la Ferme à Votre Table',
      step1Title: 'Sélection Producteur',
      step1Desc: 'Évaluation rigoureuse de chaque partenaire producteur : pratiques agricoles, certifications, qualité.',
      step2Title: 'Récolte Contrôlée',
      step2Desc: 'Supervision des conditions de récolte et d\'affinage pour chaque lot.',
      step3Title: 'Inspection Arrivée',
      step3Desc: 'Contrôle systématique à réception : analyse organoleptique et physico-chimique.',
      step4Title: 'Stockage Premium',
      step4Desc: 'Conservation dans des conditions optimales de température et d\'humidité.',
      step5Title: 'Livraison Sécurisée',
      step5Desc: 'Conditionnement protecteur et livraison rapide pour préserver les arômes.',
      certifOverline: 'Certifications',
      certifTitle: 'Des Producteurs Certifiés',
      certifDesc: 'L\'ensemble de nos fournisseurs sont certifiés selon les standards internationaux les plus exigeants.',
      c1Name: 'Agriculture Biologique',
      c1Desc: 'Label européen garantissant des pratiques agricoles sans pesticides ni OGM.',
      c2Name: 'Ecocert',
      c2Desc: 'Organisme de certification independent reconnu internationalement pour l\'agriculture bio.',
      c3Name: 'Fair Trade',
      c3Desc: 'Commerce équitable garantissant des conditions de vie et de travail dignes pour les producteurs.',
      c4Name: 'USDA Organic',
      c4Desc: 'Certification américaine pour l\'agriculture biologique, reconnue sur les marchés internationaux.',
    },
    whyDifferent: {
      overline: 'Notre Différence',
      heroTitle: 'Pourquoi Choisir',
      heroTitleAccent: 'VANELYS ?',
      heroDesc: 'Pas simplement un distributeur — un partenaire de confiance pour votre excellence gastronomique.',
      diffTitle: 'Ce Qui Nous Distingue',
      diffDesc: 'Dans un marché où la qualité est souvent compromise par les intermédiaires, VANELYS choisit une voie différente.',
      d1Title: 'Relations Directes avec les Agriculteurs',
      d1Desc: 'Nous connaissons personnellement chacun de nos producteurs. Ces relations de confiance nous permettent d\'accéder aux meilleures sélections avant quiconque.',
      d2Title: 'Qualité Constante et Vérifiable',
      d2Desc: 'Chaque lot est documenté et traçable. Vous savez exactement ce que vous recevez, d\'où ça vient, et pourquoi c\'est excellent.',
      d3Title: 'Sourçage Transparent',
      d3Desc: 'Aucun secret sur nos sources. Nous partageons volontiers les informations sur l\'origine, les producteurs et les certifications.',
      d4Title: 'Sélection Premium',
      d4Desc: 'Nous ne vendons que ce que nous choisirions nous-mêmes pour notre propre table. Aucun compromis sur la qualité.',
      d5Title: 'Export International',
      d5Desc: 'Expérience dans la logistique internationale pour livrer partout en Europe et dans le monde.',
      d6Title: 'Service Personnalisé',
      d6Desc: 'Une équipe dédiée qui comprend vos besoins spécifiques et vous accompagne dans vos projets.',
      comparisonTitle: 'VANELYS vs Marché Standard',
      compLabel: 'Critère',
      compVanelys: 'VANELYS',
      compStandard: 'Marché Standard',
      rows: [
        { label: 'Sourçage', v: 'Direct producteur', s: 'Via intermédiaires' },
        { label: 'Traçabilité', v: 'Complète & documentée', s: 'Partielle ou absente' },
        { label: 'Certification', v: 'Bio, Ecocert, Fair Trade, USDA', s: 'Variable' },
        { label: 'Sélection', v: 'Grade A Premium', s: 'Qualité mixte' },
        { label: 'Flexibilité', v: 'Sur mesure B2B/B2C', s: 'Volumes fixes' },
        { label: 'Relation', v: 'Partenariat durable', s: 'Transactionnel' },
      ],
      testimonialsTitle: 'Ils Nous Font Confiance',
    },
    buyingGuide: {
      overline: "Guide d'Achat",
      heroTitle: 'Comment Choisir',
      heroTitleAccent: 'sa Vanille ?',
      heroDesc: 'Le guide complet pour reconnaître et choisir les meilleures gousses de vanille.',
      introTitle: 'L\'Art de Choisir la Vanille',
      introDesc: 'Toutes les gousses de vanille ne se valent pas. Entre les origines, les grades, les modes de conditionnement et les arnaques fréquentes, bien choisir sa vanille nécessite un minimum de connaissances. Ce guide vous donne toutes les clés.',
      gradesTitle: 'Les Grades de Qualité',
      g1Title: 'Grade A — Gourmet',
      g1Desc: 'Les meilleures gousses. Longues (16-20+ cm), charnues, souples, luisantes et humides. Teneur en humidité de 30-35%. Idéales pour infuser dans les crèmes, glaces et ganaches.',
      g1Points: ['Longueur : 16-20+ cm', 'Humidité : 30-35%', 'Aspect : luisante, souple', 'Usage : pâtisserie fine, cuisine gastronomique'],
      g2Title: 'Grade B — Extraction',
      g2Desc: 'Gousses plus courtes, moins charnues, plus sèches. Teneur en humidité de 15-25%. Parfaites pour préparer des extraits de vanille maison ou des sucres vanillés.',
      g2Points: ['Longueur : 12-15 cm', 'Humidité : 15-25%', 'Aspect : plus sèche, moins brillante', 'Usage : extraits, sucre vanillé'],
      aromaTitle: 'Reconnaître une Bonne Vanille',
      aromaDesc: 'Une gousse de qualité se reconnaît à plusieurs critères :',
      a1: 'L\'aspect visuel : souple, luisante, sans moisissures',
      a2: 'Le toucher : charnu, gras, non cassant',
      a3: 'L\'arôme : intense, complexe, crémeux — pas chimique',
      a4: 'Le givre : des cristaux blancs (vanilline) peuvent apparaître — c\'est un signe de qualité',
      a5: 'La souplesse : elle doit pouvoir être enroulée sans casser',
      storageTitle: 'Conservation',
      storageDesc: 'Une bonne conservation permet de conserver vos gousses jusqu\'à 2 ans.',
      st1Title: 'Température',
      st1Desc: 'Conservez à température ambiante (18-22°C). Jamais au réfrigérateur — le froid cristallise les huiles aromatiques.',
      st2Title: 'Humidité',
      st2Desc: 'Un taux d\'humidité de 60-70% est idéal. Une boîte hermétique ou un tube en verre suffit.',
      st3Title: 'Lumière',
      st3Desc: 'À l\'abri de la lumière directe. Une armoire ou un tiroir sombre est parfait.',
      st4Title: 'Durée',
      st4Desc: 'Grade A : 6-12 mois. Grade B : 12-24 mois. Plus la gousse est sèche, plus elle se conserve.',
      originsTitle: 'Guide des Origines',
      buyTitle: 'Ce Qu\'il Faut Éviter',
      avoid1: 'Les gousses excessivement bon marché (souvent sèches, peu aromatiques)',
      avoid2: 'L\'absence de mention d\'origine sur l\'emballage',
      avoid3: 'Les gousses sans certification (risque de pratiques non équitables)',
      avoid4: 'Les gousses cassantes, sèches ou présentant de la moisissure',
      avoid5: 'Les prix trop variables sans explication de la qualité',
    },
    quote: {
      overline: 'Demande de Devis',
      heroTitle: 'Travaillons',
      heroTitleAccent: 'Ensemble',
      heroDesc: 'Professionnels de la gastronomie, distributeurs, marques — obtenez un devis personnalisé adapté à vos besoins.',
      formTitle: 'Votre Demande de Devis',
      formDesc: 'Remplissez ce formulaire et nous vous répondrons sous 24 heures avec une offre adaptée à vos besoins.',
      labelName: 'Nom et Prénom *',
      labelCompany: 'Société / Entreprise',
      labelEmail: 'Email professionnel *',
      labelPhone: 'Téléphone',
      labelCountry: 'Pays *',
      labelProduct: 'Produit souhaité *',
      labelQuantity: 'Quantité estimée *',
      labelMessage: 'Message / Précisions',
      placeholderName: 'Jean Dupont',
      placeholderCompany: 'Ma Pâtisserie SAS',
      placeholderEmail: 'contact@monentreprise.fr',
      placeholderPhone: '+33 6 00 00 00 00',
      placeholderCountry: 'France',
      placeholderProduct: 'Gousses de vanille Grade A Madagascar',
      placeholderQuantity: '5 kg / mois',
      placeholderMessage: 'Décrivez vos besoins spécifiques...',
      productOptions: [
        'Gousses de vanille Grade A',
        'Gousses de vanille Grade B (extraction)',
        'Vanille de Madagascar',
        'Vanille de Tahiti',
        'Vanille d\'Indonésie',
        'Vanille du Mexique',
        'Approvisionnement en vrac',
        'Cacao',
        'Fruits tropicaux',
        'Autre',
      ],
      whyTitle: 'Pourquoi Nous Contacter ?',
      why1: 'Réponse sous 24h ouvrées',
      why2: 'Offre personnalisée selon vos volumes',
      why3: 'Conseils d\'experts sur les origines',
      why4: 'Flexibilité B2B : de 500g à plusieurs tonnes',
      why5: 'Documentation complète (certificats, FDS)',
    },
    contact: {
      overline: 'Contact',
      heroTitle: 'Parlons',
      heroTitleAccent: 'Vanille',
      heroDesc: 'Une question, un projet, un partenariat ? Notre équipe est à votre écoute.',
      infoTitle: 'Nos Coordonnées',
      addressLabel: 'Adresse',
      addressVal: 'Nice, France',
      emailLabel: 'Email',
      emailVal: 'Contact@vanelys.fr',
      phoneLabel: 'Téléphone',
      phone1: '+33 7 89 01 50 50',
      phone2: '+33 6 10 25 79 50',
      formTitle: 'Envoyez-nous un Message',
      labelName: 'Nom et Prénom *',
      labelEmail: 'Email *',
      labelPhone: 'Téléphone',
      labelSubject: 'Sujet',
      labelMessage: 'Message *',
      placeholderName: 'Jean Dupont',
      placeholderEmail: 'jean@exemple.fr',
      placeholderPhone: '+33 6 00 00 00 00',
      placeholderSubject: 'Demande d\'information',
      placeholderMessage: 'Votre message...',
      mapTitle: 'Présence Internationale',
      mapDesc: 'De Nice, nous distribuons dans toute la France, l\'Europe et les marchés internationaux.',
      market1: 'France',
      market2: 'Europe',
      market3: 'International',
      hoursTitle: 'Horaires',
      hoursVal: 'Lundi–Samedi : 9h–18h\nDimanche : 9h–13h',
    },
    footer: {
      tagline: 'Distribution premium de gousses de vanille et matières premières gourmandes.',
      navigation: 'Navigation',
      contact: 'Contact',
      certif: 'Certifications',
      rights: '© 2025 VANELYS. Tous droits réservés.',
      madeIn: 'Fait à Nice, France',
    },
  },

  // ── ENGLISH ──────────────────────────────────────────────────────────────
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      products: 'Products',
      origin: 'Origin',
      quality: 'Quality',
      whyDifferent: 'Why Different',
      buyingGuide: 'Buying Guide',
      quote: 'Request a Quote',
      contact: 'Contact',
    },
    common: {
      learnMore: 'Learn More',
      discoverProducts: 'Discover our Products',
      requestQuote: 'Request a Quote',
      contactUs: 'Contact Us',
      send: 'Send',
      sending: 'Sending...',
      successTitle: 'Message sent!',
      successMsg: 'We will get back to you as soon as possible.',
      errorMsg: 'An error occurred. Please try again.',
      required: 'Required field',
      catalogueDownload: 'Download our Catalogue',
      certifications: 'Certifications',
      origin: 'Origin',
    },
    home: {
      overline: '',
      heroTitle: 'VANELYS',
      heroTitleAccent: 'FROM PARADISE',
      heroDesc: 'VANELYS is a French company based in Nice specializing in the distribution of high-quality gourmet vanilla beans sourced directly from producers across the globe.',
      ctaQuote: 'Request a Quote',
      ctaContact: 'Contact Us',
      strengthsOverline: 'Our Commitments',
      strengthsTitle: 'Why Choose VANELYS',
      s1Title: 'Direct Sourcing',
      s1Desc: 'Direct partnerships with producers for maximum quality and fair conditions for everyone.',
      s2Title: 'Full Traceability',
      s2Desc: 'Every bean is traced from farm to your door with complete transparency.',
      s3Title: 'Premium Quality',
      s3Desc: 'Rigorous selection of the finest pods for an exceptional taste experience.',
      s4Title: 'Sustainable Farming',
      s4Desc: 'Long-term partnerships with farmers committed to responsible and sustainable production.',
      chainOverline: 'Our Supply Chain',
      chainTitle: 'From Producer to Client',
      chainDesc: 'A fully controlled supply chain from end to end to guarantee freshness and quality.',
      chainStep1: 'Farmers',
      chainStep2: 'Harvest',
      chainStep3: 'Curing',
      chainStep4: 'Selection',
      chainStep5: 'Export',
      chainStep6: 'Clients',
      galleryOverline: 'Our Selection',
      galleryTitle: 'The World\'s Finest Vanilla Beans',
      galleryDesc: 'A carefully curated collection of exceptional vanilla, for professionals and discerning enthusiasts.',
      missionOverline: 'Our Mission',
      missionTitle: 'French Excellence in Vanilla',
      missionDesc: 'VANELYS is committed to bringing you the world\'s finest vanilla beans, combining traceability, premium quality and sustainable partnerships. Whether you\'re a gastronomy professional or a gourmet cooking enthusiast, we have the vanilla for you.',
      missionCta: 'Discover our Products',
    },
    about: {
      overline: 'About VANELYS',
      heroTitle: 'The Art of',
      heroSubtitle: 'Exceptional Vanilla',
      heroDesc: 'A French company founded in Nice with an international ambition: bringing the world\'s purest vanilla to the best professionals and enthusiasts.',
      storyOverline: 'Our Story',
      storyTitle: 'Born in Nice, Sourced Worldwide',
      storyDesc1: 'VANELYS was born from a deep passion for vanilla and a conviction: the finest pods deserve to be in the hands of the most demanding professionals and enthusiasts.',
      storyDesc2: 'Based in Nice, on the French Riviera, our company reaches across France, Europe and international markets. We build lasting relationships with producers certified Organic, Ecocert, Fair Trade and USDA Organic.',
      storyDesc3: 'Our philosophy: complete transparency, impeccable quality and respect for producers.',
      valuesOverline: 'Our Values',
      valuesTitle: 'What Guides Us',
      v1Title: 'Transparency',
      v1Desc: 'Complete traceability for every pod, from farm to your kitchen.',
      v2Title: 'Excellence',
      v2Desc: 'Rigorous selection and quality control at every step.',
      v3Title: 'Sustainability',
      v3Desc: 'Long-term partnerships promoting responsible agriculture.',
      v4Title: 'Passion',
      v4Desc: 'A deep love for vanilla and exceptional aromas.',
      timelineOverline: 'Our Vision',
      timelineTitle: 'From Nice to the World',
      t1Year: 'Foundation',
      t1Desc: 'VANELYS is born in Nice with the vision of distributing premium vanilla directly from producers to professionals.',
      t2Year: 'France',
      t2Desc: 'Development of the French distribution network, reaching pastry chefs, restaurants and gourmet brands.',
      t3Year: 'Europe',
      t3Desc: 'Expansion into European markets: Belgium, Switzerland, Germany, UK and beyond.',
      t4Year: 'International',
      t4Desc: 'Global ambition: export to premium markets in North America, Asia and the Middle East.',
      locationTitle: 'Nice, France',
      locationDesc: 'At the heart of the French Riviera, VANELYS operates from Nice, an internationally recognized city known for its refinement and art de vivre.',
    },
    products: {
      overline: 'Our Products',
      heroTitle: 'An Exceptional',
      heroTitleAccent: 'Selection',
      heroDesc: 'Premium vanilla beans sourced directly from certified producers, for demanding professionals and discerning individuals.',
      vanillaOverline: 'Premium Vanilla',
      vanillaTitle: 'Gourmet Vanilla Beans',
      vanillaDesc: 'Our vanilla beans are selected with the utmost rigor from the world\'s finest productions. Plump, glossy, with high vanillin content and an incomparable aromatic profile.',
      vanillaP1: 'High vanillin content for an intense fragrance',
      vanillaP2: 'Plump pods 15 to 20 cm long',
      vanillaP3: 'Oily, supple texture — a sign of quality',
      vanillaP4: 'Rich aromatic profile: cream, caramel, spice',
      formatsTitle: 'Available Formats',
      f1Title: 'Gourmet Pods',
      f1Desc: 'Premium packaging for home cooks and chefs. Grade A pods, individually packaged.',
      f2Title: 'Bulk Supply',
      f2Desc: 'Custom solutions for professionals: bakeries, ice cream makers, food manufacturers.',
      f3Title: 'Professional Quantities',
      f3Desc: 'Regular supply contracts for large accounts and distributors.',
      originsTitle: 'Our Origins',
      origin1: 'Madagascar',
      origin1Desc: 'The queen of world vanilla. Creamy, floral and woody aroma.',
      origin2: 'Tahiti',
      origin2Desc: 'Rare vanilla with floral, anise and cherry notes. Highly prized by chefs.',
      origin3: 'Indonesia',
      origin3Desc: 'Woody, slightly smoky notes. Ideal for chocolate preparations.',
      origin4: 'Mexico',
      origin4Desc: 'Historical birthplace of vanilla. Characteristic spicy and floral notes.',
      brokerageOverline: 'Complementary Activity',
      brokerageTitle: 'Commodity Brokerage',
      brokerageDesc: 'Beyond vanilla, VANELYS supports its clients in sourcing tropical raw materials. Our international network allows us to operate on complementary products.',
      b1Title: 'Cocoa',
      b1Desc: 'Premium cocoa beans, direct sourcing from certified cooperatives in Africa and Latin America.',
      b2Title: 'Tropical Fruits',
      b2Desc: 'Quality exotic and tropical fruits, selected directly at source for export markets.',
      b3Title: 'Vegetables',
      b3Desc: 'Organic and conventional vegetables, for wholesale markets and specialized distribution.',
      catalogueTitle: 'Full Catalogue',
      catalogueDesc: 'Download our product catalogue to discover our complete offer.',
    },
    origin: {
      overline: 'The Origin of Vanilla',
      heroTitle: 'The Vanilla',
      heroTitleAccent: 'Route',
      heroDesc: 'From orchid flower to dried pod: a fascinating journey through the tropics.',
      introTitle: 'The World\'s Most Mysterious Plant',
      introDesc: 'Vanilla (Vanilla planifolia) is the only orchid to produce an edible fruit. Native to Mexico, it is now grown in tropical regions worldwide. Every step of its production is an act of craftsmanship.',
      whereTitle: 'Where Does Vanilla Grow?',
      whereDesc: 'Vanilla thrives in a narrow tropical belt between the Tropics of Cancer and Capricorn. It needs a warm, humid climate, well-drained soil and a support to climb.',
      regionsTitle: 'The Major Production Regions',
      r1: 'Madagascar & Comoros',
      r1Desc: '80% of world production. Creamy, intense aroma, rich in vanillin.',
      r2: 'Tahiti & Polynesia',
      r2Desc: 'Rare vanilla (Vanilla tahitensis). Unique floral, anise and fruity notes.',
      r3: 'Indonesia & Java',
      r3Desc: 'Second largest producer. Woody, slightly smoky notes.',
      r4: 'Mexico',
      r4Desc: 'Historical birthplace. Artisanal production, spicy and floral notes.',
      pollinationTitle: 'Hand Pollination',
      pollinationDesc: 'Vanilla can only be naturally pollinated in Mexico, by an endemic bee and a specific hummingbird. Everywhere else, each flower is hand-pollinated, within just a few hours of its brief bloom.',
      pollinationFact: 'Each flower is only open for a few hours. Farmers walk the plantations every morning to hand-pollinate.',
      harvestTitle: 'The Harvest',
      harvestDesc: 'Vanilla pods ripen for 9 months after pollination. They are harvested before full maturity, when they are just beginning to yellow at their tips.',
      curingTitle: 'The Curing Process',
      curingDesc: 'Curing is the crucial step that develops the 200+ aromatic compounds in vanilla. This traditional process lasts several months and includes several essential phases.',
      c1Title: 'Blanching',
      c1Desc: 'Immersed in hot water at 65°C to stop vegetation and initiate enzymatic reactions.',
      c2Title: 'Sweating',
      c2Desc: 'Wrapped in blankets, pods sweat for 24-48 hours to develop their aromas.',
      c3Title: 'Drying',
      c3Desc: 'Slow sun drying for several weeks to reduce moisture content.',
      c4Title: 'Conditioning',
      c4Desc: 'Manual sorting, selection and packaging of pods by quality grade.',
    },
    quality: {
      overline: 'Quality & Traceability',
      heroTitle: 'Our Quality',
      heroTitleAccent: 'Commitment',
      heroDesc: 'From producer to your kitchen: every pod carries our quality signature.',
      standardsOverline: 'Our Standards',
      standardsTitle: 'The VANELYS Criteria',
      s1Title: 'Direct Sourcing',
      s1Desc: 'We work directly with producers, without intermediaries. This guarantees traceability and fair conditions for everyone.',
      s2Title: 'Rigorous Quality Control',
      s2Desc: 'Every batch is inspected: pod length, moisture content, visual appearance, aromatic profile and vanillin content.',
      s3Title: 'Complete Traceability',
      s3Desc: 'Every delivery comes with complete documentation: origin, producer, certification, harvest date.',
      s4Title: 'Sustainable Partnerships',
      s4Desc: 'Our relationships with producers are long-term. We invest in their development and well-being.',
      processOverline: 'Our Process',
      processTitle: 'From Farm to Your Table',
      step1Title: 'Producer Selection',
      step1Desc: 'Rigorous evaluation of each partner producer: farming practices, certifications, quality.',
      step2Title: 'Controlled Harvest',
      step2Desc: 'Supervision of harvest and curing conditions for each batch.',
      step3Title: 'Arrival Inspection',
      step3Desc: 'Systematic check on receipt: organoleptic and physico-chemical analysis.',
      step4Title: 'Premium Storage',
      step4Desc: 'Storage under optimal temperature and humidity conditions.',
      step5Title: 'Secure Delivery',
      step5Desc: 'Protective packaging and prompt delivery to preserve aromas.',
      certifOverline: 'Certifications',
      certifTitle: 'Certified Producers',
      certifDesc: 'All our suppliers are certified to the most demanding international standards.',
      c1Name: 'Organic Farming',
      c1Desc: 'European label guaranteeing farming practices free of pesticides and GMOs.',
      c2Name: 'Ecocert',
      c2Desc: 'Internationally recognized independent certification body for organic farming.',
      c3Name: 'Fair Trade',
      c3Desc: 'Fair trade certification guaranteeing decent living and working conditions for producers.',
      c4Name: 'USDA Organic',
      c4Desc: 'American organic farming certification, recognized on international markets.',
    },
    whyDifferent: {
      overline: 'Why Different',
      heroTitle: 'Why Choose',
      heroTitleAccent: 'VANELYS?',
      heroDesc: 'Not just a distributor — a trusted partner for your gastronomic excellence.',
      diffTitle: 'What Sets Us Apart',
      diffDesc: 'In a market where quality is often compromised by intermediaries, VANELYS chooses a different path.',
      d1Title: 'Direct Farmer Relationships',
      d1Desc: 'We personally know each of our producers. These trusted relationships give us access to the finest selections before anyone else.',
      d2Title: 'Consistent, Verifiable Quality',
      d2Desc: 'Every batch is documented and traceable. You know exactly what you receive, where it comes from, and why it\'s excellent.',
      d3Title: 'Transparent Sourcing',
      d3Desc: 'No secrets about our sources. We willingly share information about origin, producers and certifications.',
      d4Title: 'Premium Selection',
      d4Desc: 'We only sell what we would choose for our own table. No compromise on quality.',
      d5Title: 'International Export',
      d5Desc: 'Experience in international logistics to deliver anywhere in Europe and worldwide.',
      d6Title: 'Personalised Service',
      d6Desc: 'A dedicated team that understands your specific needs and accompanies you in your projects.',
      comparisonTitle: 'VANELYS vs Standard Market',
      compLabel: 'Criteria',
      compVanelys: 'VANELYS',
      compStandard: 'Standard Market',
      rows: [
        { label: 'Sourcing', v: 'Direct from producer', s: 'Via intermediaries' },
        { label: 'Traceability', v: 'Complete & documented', s: 'Partial or absent' },
        { label: 'Certification', v: 'Bio, Ecocert, Fair Trade, USDA', s: 'Variable' },
        { label: 'Selection', v: 'Grade A Premium', s: 'Mixed quality' },
        { label: 'Flexibility', v: 'Custom B2B/B2C', s: 'Fixed volumes' },
        { label: 'Relationship', v: 'Sustainable partnership', s: 'Transactional' },
      ],
      testimonialsTitle: 'They Trust Us',
    },
    buyingGuide: {
      overline: 'Buying Guide',
      heroTitle: 'How to Choose',
      heroTitleAccent: 'your Vanilla',
      heroDesc: 'The complete guide to recognising and choosing the finest vanilla beans.',
      introTitle: 'The Art of Choosing Vanilla',
      introDesc: 'Not all vanilla beans are equal. Between origins, grades, packaging formats and common pitfalls, choosing vanilla well requires some knowledge. This guide gives you all the keys.',
      gradesTitle: 'Quality Grades',
      g1Title: 'Grade A — Gourmet',
      g1Desc: 'The finest pods. Long (16-20+ cm), plump, supple, glossy and moist. Moisture content of 30-35%. Ideal for infusing in creams, ice creams and ganaches.',
      g1Points: ['Length: 16-20+ cm', 'Moisture: 30-35%', 'Appearance: glossy, supple', 'Use: fine pastry, gourmet cooking'],
      g2Title: 'Grade B — Extraction',
      g2Desc: 'Shorter, less plump, drier pods. Moisture content of 15-25%. Perfect for making homemade vanilla extract or vanilla sugar.',
      g2Points: ['Length: 12-15 cm', 'Moisture: 15-25%', 'Appearance: drier, less shiny', 'Use: extracts, vanilla sugar'],
      aromaTitle: 'Recognising Quality Vanilla',
      aromaDesc: 'A quality pod can be identified by several criteria:',
      a1: 'Visual appearance: supple, glossy, no mould',
      a2: 'Touch: plump, oily, not brittle',
      a3: 'Aroma: intense, complex, creamy — not chemical',
      a4: 'Frost: white crystals (vanillin) may appear — a sign of quality',
      a5: 'Flexibility: it should be rollable without breaking',
      storageTitle: 'Storage',
      storageDesc: 'Proper storage allows your pods to keep for up to 2 years.',
      st1Title: 'Temperature',
      st1Desc: 'Store at room temperature (18-22°C). Never refrigerate — cold crystallises the aromatic oils.',
      st2Title: 'Humidity',
      st2Desc: 'A humidity level of 60-70% is ideal. An airtight box or glass tube is sufficient.',
      st3Title: 'Light',
      st3Desc: 'Away from direct light. A dark cupboard or drawer is perfect.',
      st4Title: 'Duration',
      st4Desc: 'Grade A: 6-12 months. Grade B: 12-24 months. The drier the pod, the longer it keeps.',
      originsTitle: 'Origins Guide',
      buyTitle: 'What to Avoid',
      avoid1: 'Excessively cheap pods (often dry, little aroma)',
      avoid2: 'No mention of origin on the packaging',
      avoid3: 'Pods without certification (risk of unfair practices)',
      avoid4: 'Brittle, dry or mouldy pods',
      avoid5: 'Highly variable prices without quality explanation',
    },
    quote: {
      overline: 'Quote Request',
      heroTitle: "Let's Work",
      heroTitleAccent: 'Together',
      heroDesc: 'Gastronomy professionals, distributors, brands — get a personalised quote tailored to your needs.',
      formTitle: 'Your Quote Request',
      formDesc: 'Fill in this form and we will reply within 24 hours with an offer tailored to your needs.',
      labelName: 'Full Name *',
      labelCompany: 'Company / Business',
      labelEmail: 'Professional Email *',
      labelPhone: 'Phone',
      labelCountry: 'Country *',
      labelProduct: 'Product of Interest *',
      labelQuantity: 'Estimated Quantity *',
      labelMessage: 'Message / Details',
      placeholderName: 'John Smith',
      placeholderCompany: 'My Patisserie Ltd',
      placeholderEmail: 'contact@mycompany.com',
      placeholderPhone: '+44 7700 000000',
      placeholderCountry: 'United Kingdom',
      placeholderProduct: 'Grade A Madagascar vanilla pods',
      placeholderQuantity: '5 kg / month',
      placeholderMessage: 'Describe your specific needs...',
      productOptions: [
        'Grade A Vanilla Pods',
        'Grade B Vanilla Pods (extraction)',
        'Madagascar Vanilla',
        'Tahitian Vanilla',
        'Indonesian Vanilla',
        'Mexican Vanilla',
        'Bulk Supply',
        'Cocoa',
        'Tropical Fruits',
        'Other',
      ],
      whyTitle: 'Why Contact Us?',
      why1: 'Response within 24 business hours',
      why2: 'Personalised offer based on your volumes',
      why3: 'Expert advice on origins',
      why4: 'B2B flexibility: from 500g to several tonnes',
      why5: 'Complete documentation (certificates, SDS)',
    },
    contact: {
      overline: 'Contact',
      heroTitle: "Let's Talk",
      heroTitleAccent: 'Vanilla',
      heroDesc: 'A question, a project, a partnership? Our team is here for you.',
      infoTitle: 'Our Contact Details',
      addressLabel: 'Address',
      addressVal: 'Nice, France',
      emailLabel: 'Email',
      emailVal: 'Contact@vanelys.fr',
      phoneLabel: 'Phone',
      phone1: '+33 7 89 01 50 50',
      phone2: '+33 6 10 25 79 50',
      formTitle: 'Send Us a Message',
      labelName: 'Full Name *',
      labelEmail: 'Email *',
      labelPhone: 'Phone',
      labelSubject: 'Subject',
      labelMessage: 'Message *',
      placeholderName: 'John Smith',
      placeholderEmail: 'john@example.com',
      placeholderPhone: '+44 7700 000000',
      placeholderSubject: 'Information request',
      placeholderMessage: 'Your message...',
      mapTitle: 'International Presence',
      mapDesc: 'From Nice, we distribute throughout France, Europe and international markets.',
      market1: 'France',
      market2: 'Europe',
      market3: 'International',
      hoursTitle: 'Hours',
      hoursVal: 'Monday–Saturday: 9am–6pm \nSunday: 9am–1pm',
    },
    footer: {
      tagline: 'Premium distribution of vanilla beans and gourmet commodities.',
      navigation: 'Navigation',
      contact: 'Contact',
      certif: 'Certifications',
      rights: '© 2025 VANELYS. All rights reserved.',
      madeIn: 'Made in Nice, France',
    },
  },
};
